import { LegalPage } from "./Legal";

export default function Returns() {
  return <LegalPage base="returns" path="/retours" testid="returns-page" />;
}
